export const communityResources = {
    title: 'Community Resources',
    happy: `
    <p>Talking things through with someone can lift your mood.</p>
    <p>
      Try Alzheimer Scotland 24 hr helpline -
      <a href="tel:08008886678">0800 888 6678</a> - or Silverline Scotland
      - <a href="tel:08004708090">0800 4 70 80 90</a>.
    </p>
    <p>
      Details of local groups can be found at
      <a
        rel="noopener"
        href="https://inverclydelife.com/"
        target="_blank"
        title="Inverclyde Life"
        >Inverclyde Life</a
      >.
    </p>
    <p>
      If you need support to access groups, try
      <a
        rel="noopener"
        href="https://inverclydelife.com/services/community-connectors"
        target="_blank"
        title="Inverclyde community connectors"
        >Inverclyde Community Connectors</a
      >
      Speak to a local Community Connector
      <a href="tel:01475728628">01475 728628</a> or email
      <a
        rel="noopener"
        href="mailto:enquiries@yourvoice.org.uk"
        target="_blank"
        >enquiries@yourvoice.org.uk</a
      >. They may be able to help you link in with local support services.
    </p>
    <p>
      Speak to a Community Link Worker who works in your local GP
      practice: call your GP Practice, or call
      <a href="tel:01475711733">01475 711 733</a> or email
      <a
        rel="noopener"
        href="mailto:admin@cvsinverclyde.org.uk"
        target="_blank"
        >admin@cvsinverclyde.org.uk</a
      >.Community Links Workers can help you to access relevant local
      services.
    </p>
    <p>
      The
      <a
        rel="noopener"
        href="https://inverclydelife.com/services/community-connectors"
        target="_blank"
        title="Inverclyde Life Community Connectors"
        >Inverclyde Life</a
      >
      webpage has details of local groups and services.
    </p>
      `,
    relaxed: `<p>When experiencing stress or anxiety, it can be helpful to tell others about how we are feeling. Reaching out to
      family, friends or carers and letting them know that you are struggling can help. </p>
    <p>Try <a rel="noopener" href="https://inverclydelife.com/services/community-connectors" target="_blank"
          title="Inverclyde community connectors">Inverclyde Community Connectors</a> Speak to a local Community
      Connector<a href="tel:01475728628">01475 728628</a>
      or email <a rel="noopener" href="mailto:enquiries@yourvoice.org.uk" target="_blank">enquiries@yourvoice.org.uk</a>.
      They may be able to
      help you link in with local support services.</p>
    <p>Speak to a Community Link Worker who works in your local GP practice: call your GP Practice, or call <a
          href="tel:01475711733">01475 711 733</a> or email <a rel="noopener" href="mailto:admin@cvsinverclyde.org.uk"
          target="_blank">admin@cvsinverclyde.org.uk</a>. Community Links Workers
      can help you to access relevant local services.</p>
    <p>Your local Alzheimer Scotland Dementia Advisor may also be able to offer support and can be contacted on: <a
          href="tel:01475261100">01475 261100</a>.</p>
    <p>Mind UK offers useful <a rel="noopener"
          href="https://www.mind.org.uk/information-support/tips-for-everyday-living/relaxation/relaxation-tips/"
          target="_blank" title="MIND UK relaxation tips">tips and exercises on relaxation</a>.</p>` ,
    active: `<p><strong>Services and resources to try</strong></p>
      <p><a rel="noopener"
              href="https://www.nhsinform.scot/scotlands-service-directory/health-and-wellbeing-services/56%201inv1116"
              target="_blank" title="Quit Your Way Inverclyde">Quit your way</a> Quit your way Inverclyde is a community
          service to help you to stop smoking.</p>
      <p>Try <a rel="noopener" href="https://inverclydelife.com/services/community-connectors" target="_blank"
              title="Inverclyde community connectors">Inverclyde Community Connectors</a> Speak to a local Community
          Connector <a href="tel:01475728628">01475 728628</a>
          or email <a rel="noopener" href="mailto:enquiries@yourvoice.org.uk" target="_blank">enquiries@yourvoice.org.uk</a>.
          They may be able to
          help you link in with local support services.</p>
      <p>Speak to a Community Link Worker who works in your local GP practice: call your GP Practice, or call <a
              href="tel:01475711733">01475 711 733</a> or email <a rel="noopener" href="mailto:admin@cvsinverclyde.org.uk"
              target="_blank">admin@cvsinverclyde.org.uk</a>. Community Links Workers
          can help you to access relevant local services.</p>
      <p><a rel="noopener" href="https://www.inverclydeleisure.com/health/live-active/" target="_blank"
              title="Live active">Live Active</a> The Live Active referral scheme
          is a joint partnership between Inverclyde Leisure and NHS Greater Glasgow &amp; Clyde. It aims to help people
          increase their level of physical activity, and gain core skills to lead an active life. Participants must be
          referred by their GP, practice nurse or other health professional who will assess their suitability to be referred
          onto the scheme.</p>
      <p>The <a rel="noopener" href="https://www.pathsforall.org.uk/walk-project/the-bothy" target="_blank"
              title="Paths for All">Paths for
              All</a> project in Inverclyde offers a number of health walks.</p>` ,
    rested: `<p>A variety of community activities are available in Inverclyde. Try keeping up an activity that you enjoy - or try
    something new. For ideas on what you can do, and information about organisations that provide local activities,
    follow these links: </p>
<ul>
    <li><a rel="noopener" href="http://www.inverclydeleisure.com" target="_blank" title="Inverclyde Leisure">Inverclyde
            Leisure</a>
    </li>
    <li><a rel="noopener" href="https://discoverinverclyde.com/things-to-do/" target="_blank"
            title="Discover Inverclyde: things to do">Discover Inverclyde</a></li>
</ul>`,
    interests: `<p>There are lots of things you can do in your local community. Try the <a rel="noopener"
    href="https://inverclydelife.com/" target="_blank" title="Inverclyde Life Directory">Inverclyde Life
    Directory</a>.</p>
<p>Alzheimer Scotland staff and volunteers have <a rel="noopener" href="https://www.alzscot.org/guided-activities"
    target="_blank" title="Alzheimer Scotland guided activities">videos showing activities</a> you can be involved
in, such as
gentle exercise and reminiscence.</p>
<p>You can speak to a dementia advisor at Alzheimer Scotland Dementia Resource Centre in Inverclyde: </p>
<p>Telephone: <a rel="noopener" href="tel:01475261100" target="_blank">01475 261100</a></p>
<p>Address: </p>
<p>Alzheimer Scotland Dementia Resource Centre <br />1 Nicol Street <br />Greenock<br />PA16 7EN</p>`,
};

export default communityResources;
